export default {
  expenseList: [],
};
